import * as React from "react";
import { DepositSort } from "../../../../../Wrap/Constants/Enums/Domain/DepositSort";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { SortDirection } from "../../../../../Wrap/Core/SortingAndPaging/SortDirection";
import { DepositProductsQuery } from "../../../../../Wrap/Models/Domains/Investment/DepositProductsQuery";
import { InstrumentSearchQuery } from "../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { ISearchProps } from "../../Resource/Content";
import { AdvancedSearch } from "../Shared/AdvancedSearch";
import { FavouritesToggle } from "../Shared/FavouritesToggle";
import { DepositSearchResults } from "./DepositSearchResult";
import DepositsSearch from "./DepositsSearch";
import { UnmountClosed } from "react-collapse";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { ResearchISTDispatcher } from "../../../../Dashboard/Components/ToolsAndLiterature/Store/Variable";
import { useRef } from "react";

export const Deposits = (props: ISearchProps) => {
    const wrapperRef = useRef(null);
    const [onFavourite, setOnFavourite] = React.useState(false);
    const [favouriteData, setFavouriteData] = React.useState(null);
    const [currentPage, setCurrentPage] = React.useState(1);

    const query: InstrumentSearchQuery = {
        ProductTypes: [ProductType.CashProduct],
        ProductWrapperTypes: [props.type],
        ServiceProposition: props.accountServiceProposition,
    };

    if (props.canBeBought) {
        query["CanBeBought"] = true;
    }
    if (props.canBeSold) {
        query["CanBeSold"] = true;
    }

    const toggleFavourite = (isOn) => {
        if (props.researchIst && wrapperRef && wrapperRef.current) {wrapperRef.current.close();}
        if (!isOn) {
            ResearchISTDispatcher.dispatch({ actionType: ActionType.Success, payload: null });
            return setOnFavourite(isOn);
        }
        return searchFavourite(1);
    };

    const searchFavourite = (pageIndex) => {
        const query: DepositProductsQuery = {
            CurrentPage: pageIndex,
        };
        if (props.canBeBought) {
            query["CanBeBought"] = true;
        }
        if (props.canBeSold) {
            query["CanBeSold"] = true;
        }
        query["IncludeFavouritesOnly"] = true;
        query["ProductWrapperTypes"] = [props.type];
        query["ServiceProposition"] = props.accountServiceProposition;
        query["Sorting"] = [{ Field: DepositSort.Issuer, Direction: SortDirection.Ascending }];
        InvestmentSelectionAction.searchDepositProducts(
            query,
            props.hiercharyId,
            (data) => {
                ResearchISTDispatcher.dispatch({ actionType: ActionType.Success, payload: data.Results });
                setOnFavourite(true);
                setFavouriteData(data);
            },
            props.researchIst ? 9999 : null
        );
    };

    return (
        <div>
            <div className="row row-right mb-10">
                {/*
                This button will be implemented in TS2.1

                <div className="col-auto">
                    <button className="upload-button">
                        <span className="text">Upload xls</span>
                        <span className="icon" aria-hidden={true}></span>
                    </button>
                </div> */}
            </div>

            {!props.researchIst && (
                <UnmountClosed isOpened={onFavourite}>
                    {favouriteData && (
                        <DepositSearchResults
                            data={favouriteData}
                            allocationTable={props.tableData}
                            onPageChange={(i) => searchFavourite(i)}
                            isFavourite
                            index={props.index}
                            researchIst={false}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    )}
                </UnmountClosed>
            )}

            <AdvancedSearch
                query={query}
                hiercharyId={props.hiercharyId}
                index={props.index}
                cssWrapper="mb-24"
                showResult={wrapperRef}
                forceAdvanced={true}
                showAutoComplete={false}
            >
                <DepositsSearch
                    ref={wrapperRef}
                    hiercharyId={props.hiercharyId}
                    tableData={props.tableData}
                    type={props.type}
                    index={props.index}
                    researchIst={props.researchIst}
                    accountServiceProposition={props.accountServiceProposition}
                    canBeBought={props.canBeBought}
                    canBeSold={props.canBeSold}
                    CanBeTransferred={props.CanBeTransferred}
                    batchType={props.batchType}
                />
            </AdvancedSearch>
        </div>
    );
};
